import COS from "cos-js-sdk-v5";
const cosf = new COS({
  SecretId: "AKIDMYZNyKSN3XqEOIyRhiTzJQHsgHemeKo3",
  SecretKey: "2PeiZDyZzJTSEl4B6mDPPDn9HDzWoumP",
});
function getCosUrl(url, width, height) {
  if (width && height) {
    return process.env.VUE_APP_URL + url + `?imageMogr2/thumbnail/${width}x${height}!`
  } else {
    return process.env.VUE_APP_URL + url
  }
}
export default getCosUrl;
